export default "__VITE_ASSET__Cv19JfpF__"